export const MODAL_WIDTH = 688;
export const MODAL_MAX_WIDTH = MODAL_WIDTH;
